(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/possibleConstructorReturn', 'babel-runtime/helpers/inherits', 'react', 'react-emotion', '@material-ui/core/Button', '@material-ui/core/ClickAwayListener', '@material-ui/core/Grow', '@material-ui/core/Paper', '@material-ui/core/Popper', '@material-ui/core/Avatar', '@material-ui/icons/AccountCircle', '@material-ui/icons/ExpandMore', '../styles', '../elements'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('babel-runtime/helpers/extends'), require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('react'), require('react-emotion'), require('@material-ui/core/Button'), require('@material-ui/core/ClickAwayListener'), require('@material-ui/core/Grow'), require('@material-ui/core/Paper'), require('@material-ui/core/Popper'), require('@material-ui/core/Avatar'), require('@material-ui/icons/AccountCircle'), require('@material-ui/icons/ExpandMore'), require('../styles'), require('../elements'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global._extends, global.classCallCheck, global.possibleConstructorReturn, global.inherits, global.react, global.reactEmotion, global.Button, global.ClickAwayListener, global.Grow, global.Paper, global.Popper, global.Avatar, global.AccountCircle, global.ExpandMore, global.styles, global.elements);
    global.Profile = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _extends2, _classCallCheck2, _possibleConstructorReturn2, _inherits2, _react, _reactEmotion, _Button, _ClickAwayListener, _Grow, _Paper, _Popper, _Avatar, _AccountCircle, _ExpandMore, _styles, _elements) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _extends3 = _interopRequireDefault(_extends2);

  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

  var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

  var _inherits3 = _interopRequireDefault(_inherits2);

  var React = _interopRequireWildcard(_react);

  var _Button2 = _interopRequireDefault(_Button);

  var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

  var _Grow2 = _interopRequireDefault(_Grow);

  var _Paper2 = _interopRequireDefault(_Paper);

  var _Popper2 = _interopRequireDefault(_Popper);

  var _Avatar2 = _interopRequireDefault(_Avatar);

  var _AccountCircle2 = _interopRequireDefault(_AccountCircle);

  var _ExpandMore2 = _interopRequireDefault(_ExpandMore);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    margin-top: 0;\n    margin-bottom: 0;\n  '], ['\n    margin-top: 0;\n    margin-bottom: 0;\n  ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    z-index: 1;\n  '], ['\n    z-index: 1;\n  ']),
      _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(['\n    && {\n      width: 1rem;\n      height: 1.5rem;\n      background-color: transparent;\n    }\n  '], ['\n    && {\n      width: 1rem;\n      height: 1.5rem;\n      background-color: transparent;\n    }\n  ']),
      _templateObject4 = (0, _taggedTemplateLiteralLoose3.default)(['\n    color: ', ';\n    font-size: 17px !important;\n  '], ['\n    color: ', ';\n    font-size: 17px !important;\n  ']),
      _templateObject5 = (0, _taggedTemplateLiteralLoose3.default)(['\n    text-overflow: ellipsis;\n    overflow: hidden;\n    line-height: 1.23;\n    padding: 1rem;\n  '], ['\n    text-overflow: ellipsis;\n    overflow: hidden;\n    line-height: 1.23;\n    padding: 1rem;\n  ']),
      _templateObject6 = (0, _taggedTemplateLiteralLoose3.default)(['\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n  '], ['\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n  ']),
      _templateObject7 = (0, _taggedTemplateLiteralLoose3.default)(['\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    padding: 0 0 0 5px;\n    font-size: 13px !important;\n  '], ['\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    padding: 0 0 0 5px;\n    font-size: 13px !important;\n  ']),
      _templateObject8 = (0, _taggedTemplateLiteralLoose3.default)(['\n    && {\n      width: ', ';\n      box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14),\n        0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.4);\n    }\n  '], ['\n    && {\n      width: ', ';\n      box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14),\n        0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.4);\n    }\n  ']);

  var Paragraph = _elements.typography.Paragraph,
      Note = _elements.typography.Note;

  var PROFILE_DROPDOWN_TRIGGER_WIDTH = '216px';
  var PROFILE_DROPDOWN_WIDTH = '208px';
  /*
    For now, this component takes a user's email, name, and profile picture uri to render
    the dropdown button and the first item in the dropdown. It also takes children, where
    can render additional items in the dropdown.
  */

  var Profile = function (_React$Component) {
    (0, _inherits3.default)(Profile, _React$Component);

    function Profile() {
      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, Profile);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
        open: false
      }, _this.profileButton = React.createRef(), _this.handleToggle = function () {
        _this.setState(function (prevState) {
          return { open: !prevState.open };
        });
      }, _this.handleClose = function (event) {
        // This prevents both handleToggle and handleClose being called on profile button click
        var clickedNode = event.target;
        var profileButtonRef = _this.profileButton.current;
        var isNodeChildOfProfileButton = profileButtonRef && profileButtonRef.contains(clickedNode);

        if (isNodeChildOfProfileButton) {
          return;
        }

        _this.setState({ open: false });
      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    Profile.prototype.render = function render() {
      var _this2 = this;

      var _props = this.props,
          name = _props.name,
          profilePictureURI = _props.profilePictureURI,
          emailAddress = _props.emailAddress,
          accountType = _props.accountType,
          children = _props.children,
          entityName = _props.entityName,
          className = _props.className,
          fullName = _props.fullName;
      var open = this.state.open;

      var hasChildren = React.Children.count(children) > 0;

      return React.createElement(
        'div',
        { className: className },
        React.createElement(
          _Button2.default,
          {
            buttonRef: this.profileButton,
            'aria-owns': open ? 'menu-list-grow' : null,
            'aria-haspopup': 'true',
            'data-testid': 'click-profile-dropdown',
            'aria-label': 'Profile Dropdown',
            onClick: this.handleToggle,
            style: {
              display: 'flex',
              width: PROFILE_DROPDOWN_TRIGGER_WIDTH,
              height: '100%',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '0px 1rem',
              borderRadius: '0px',
              textTransform: 'none'
            }
          },
          React.createElement(
            'div',
            { className: classNames.profileDropdownTriggerContent },
            profilePictureURI ? React.createElement(_Avatar2.default, { className: classNames.avatar, src: profilePictureURI }) : React.createElement(
              _Avatar2.default,
              { className: classNames.avatar },
              React.createElement(_AccountCircle2.default, { className: classNames.icon })
            ),
            React.createElement(
              Paragraph,
              { className: classNames.profileButtonName },
              name
            )
          ),
          React.createElement(_ExpandMore2.default, { className: classNames.icon })
        ),
        React.createElement(
          _Popper2.default,
          {
            open: open,
            anchorEl: this.profileButton.current,
            transition: true,
            disablePortal: true,
            placement: 'bottom-start',
            className: classNames.popper
          },
          function (_ref) {
            var TransitionProps = _ref.TransitionProps;
            return React.createElement(
              _Grow2.default,
              (0, _extends3.default)({}, TransitionProps, {
                id: 'menu-list-grow',
                style: { transformOrigin: 'center top' }
              }),
              React.createElement(
                _Paper2.default,
                { className: classNames.dropdownMenu },
                React.createElement(
                  _ClickAwayListener2.default,
                  { onClickAway: _this2.handleClose },
                  React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      { className: classNames.dropdownHeader },
                      React.createElement(
                        'div',
                        null,
                        React.createElement(
                          Paragraph,
                          null,
                          fullName ? fullName : accountType
                        )
                      ),
                      React.createElement(
                        Note,
                        null,
                        emailAddress
                      ),
                      entityName && React.createElement(
                        'div',
                        null,
                        React.createElement(
                          Note,
                          { bold: true },
                          entityName
                        )
                      )
                    ),
                    hasChildren && React.createElement('hr', { className: classNames.hrReset }),
                    children
                  )
                )
              )
            );
          }
        )
      );
    };

    return Profile;
  }(React.Component);

  Profile.defaultProps = { className: '' };


  var classNames = {
    hrReset: (0, _reactEmotion.css)(_templateObject),
    popper: (0, _reactEmotion.css)(_templateObject2),
    avatar: (0, _reactEmotion.css)(_templateObject3),
    icon: (0, _reactEmotion.css)(_templateObject4, _styles.colors.prussian),
    dropdownHeader: (0, _reactEmotion.css)(_templateObject5),
    profileDropdownTriggerContent: (0, _reactEmotion.css)(_templateObject6),
    profileButtonName: (0, _reactEmotion.css)(_templateObject7),
    dropdownMenu: (0, _reactEmotion.css)(_templateObject8, PROFILE_DROPDOWN_WIDTH)
  };

  exports.default = Profile;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Profile.js
// module id = 2019
// module chunks = 1